import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React, { useRef, useState } from 'react';
import styled from '@emotion/styled';
import { theme } from '@/layout/GlobalStyles';
import { ReactComponent as Arrow } from '../images/svgs/arrow-slider.svg';

const Container = styled.div`
    overflow: hidden;
    margin-bottom: 72px;
    @media ${theme.device.laptop} {
        margin-top: -72px;
    }
`;

const MainImage = styled.div`
    margin: 32px auto;
    @media ${theme.device.laptop} {
        margin: 64px auto;
        width: 700px;
    }
`;

interface SlideProps {
    index: number;
}

const SlideContainer = styled.div<SlideProps>`
    display: flex;
    -ms-overflow-style: none;
    scrollbar-width: none;
    position: relative;
    gap: 15px;
    padding: 0px 0px;
    margin: 32px 0px;
    overflow-x: scroll;
    justify-content: start;
    .outline {
        img {
            outline: 200px solid ${theme.colors.yellow3};
        }
    }
    &::-webkit-scrollbar {
        display: none;
    }
    div {
        position: relative;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        width: 315px;
        img {
            margin: auto;
            cursor: pointer;
            width: 97.5%;
            height: 95%;
        }
    }
    @media ${theme.device.tablet} {
    }
    @media ${theme.device.laptop} {
        width: 1005px;
    }
`;

const ButtonContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    button {
        cursor: pointer;
        background: none;
        svg {
            fill: ${theme.colors.gray4};
        }
        border: none;
    }
    button:last-of-type {
        svg {
            transform: rotate(180deg);
        }
    }
`;

export const VirtualTourSlider = () => {
    const [index, setIndex] = useState(0);
    const slideRef = useRef<HTMLDivElement>(null);

    const data = useStaticQuery(graphql`
        query Photos {
            allFile(filter: { relativeDirectory: { eq: "5-virtual-tour" } }, sort: { name: ASC }) {
                edges {
                    node {
                        id
                        childImageSharp {
                            gatsbyImageData(quality: 90, placeholder: NONE)
                        }
                        name
                    }
                }
            }
        }
    `);
    const images = data.allFile.edges;

    const slideClick = (direction: 'back' | 'next') => {
        const slideRefCurrent = slideRef.current;
        if (!slideRefCurrent) {
            return;
        }

        const slideWidth = (slideRef.current.childNodes[0] as HTMLElement).offsetWidth + 15;
        const slidePosition = slideRefCurrent.scrollLeft;

        if (direction === 'back' && index > 0) {
            setIndex(index => index - 1);
            slideRefCurrent.scrollTo({ left: slidePosition - slideWidth, behavior: 'smooth' });
        }

        if (direction === 'next' && index < images.length - 1) {
            setIndex(index => index + 1);
            slideRefCurrent.scrollTo({ left: slidePosition + slideWidth, behavior: 'smooth' });
        }
    };
    return (
        <Container>
            <MainImage>
                <GatsbyImage image={images[index].node.childImageSharp.gatsbyImageData} alt={''} />
            </MainImage>
            <SlideContainer ref={slideRef} index={index}>
                {images.map((image: any, i: number) => {
                    return (
                        <button
                            onClick={() => setIndex(i)}
                            key={image.name}
                            style={{ border: 'none', background: 'none' }}
                        >
                            <GatsbyImage
                                className={`${i === index && 'outline'}`}
                                image={image.node.childImageSharp.gatsbyImageData}
                                alt={''}
                            />
                        </button>
                    );
                })}
            </SlideContainer>
            <ButtonContainer>
                <button disabled={index === 0} onClick={() => slideClick('back')}>
                    {' '}
                    {index === 0 ? <Arrow style={{ opacity: '.8' }} /> : <Arrow />}
                </button>
                <button disabled={index === images.length - 1} onClick={() => slideClick('next')}>
                    {index === images.length - 1 ? <Arrow style={{ opacity: '.8' }} /> : <Arrow />}
                </button>
            </ButtonContainer>
        </Container>
    );
};
